import React, { useState, useRef } from 'react';
import './Level2.css';
import { useNavigate } from 'react-router-dom';

import SparkImg from '../Assets/Fx/Spark.gif';
import SparkSfx from '../Assets/Sounds/SparkSfx.wav'

import Red1 from '../Assets/Icons/Red1.svg';
import Red2 from '../Assets/Icons/Red2.svg';
import Green1 from '../Assets/Icons/Green1.svg';
import Green2 from '../Assets/Icons/Green2.svg';
import Blue1 from '../Assets/Icons/Blue1.svg';
import Blue2 from '../Assets/Icons/Blue2.svg';
import WinScreen from '../Components/Layout/WinScreen';

const Level2 = () => {
    const [currentStage, setCurrentStage] = useState(1); 
    const [selectedContact, setSelectedContact] = useState(null);
    const [connectedPairs, setConnectedPairs] = useState({ red: false, green: false, blue: false });
    const navigate = useNavigate();
    const [isWon, setIsWon] = useState(false);

    const [showSpark, setShowSpark] = useState(false);
    const [sparkPos, setSparkPos] = useState({ left: 0, top: 0 });
    

    const sparkTimer = useRef(null);

    const CONTACTS_CONFIG = {
        red: {
            start: { id: 'r_s', x: 215 + 35, y: 80 + 35 }, 
            end: { id: 'r_e', x: 410 + 60, y: 450 + 35 }   
        },
        green: {
            start: { id: 'g_s', x: 215 + 35, y: 215 + 35 },
            end: { id: 'g_e', x: 525 + 80, y: 445 + 35 }   
        },
        blue: {
            start: { id: 'b_s', x: 205 + 40, y: 335 + 40 }, 
            end: { id: 'b_e', x: 670 + 40, y: 445 + 40 }   
        }
    };

    const playSparkSound = () => {
        const sfx = new Audio(SparkSfx);
        sfx.volume = 0.6; 
        sfx.play();
    };


    const triggerSpark = (leftPos, topPos) => {
        setSparkPos({ left: leftPos, top: topPos });
        setShowSpark(true);
        setSelectedContact(null); 

        playSparkSound();

        if (sparkTimer.current) clearTimeout(sparkTimer.current);
        sparkTimer.current = setTimeout(() => setShowSpark(false), 800);
    };


    const handleContactClick = (e, colorKey, type, contactId) => {
        e.stopPropagation(); 

        const colorStageMap = { red: 1, green: 2, blue: 3 };
        
     
        const fireNodePenalty = () => {
            const rect = e.currentTarget.getBoundingClientRect();
            const fixAreaElement = document.querySelector('.FixArea').getBoundingClientRect();
            triggerSpark(
                rect.left - fixAreaElement.left + (rect.width / 2) - 50,
                rect.top - fixAreaElement.top + (rect.height / 2) - 50
            );
        };


        if (colorStageMap[colorKey] !== currentStage || connectedPairs[colorKey]) {
            fireNodePenalty();
            return;
        }


        if (!selectedContact) {
            setSelectedContact({ colorKey, type, contactId });
            return;
        }

 
        if (selectedContact.contactId === contactId) {
            setSelectedContact(null);
            return;
        }


        if (selectedContact.colorKey === colorKey && selectedContact.type !== type) {
            setConnectedPairs(prev => ({ ...prev, [colorKey]: true }));
            setSelectedContact(null);
            
            if (currentStage < 3) {
                setCurrentStage(prev => prev + 1);
            } else {
                setIsWon(true);
            }
        } 

        else {
            fireNodePenalty();
        }
    };

    const handleBackgroundClick = (e) => {

        const rect = e.currentTarget.getBoundingClientRect();
        

        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;

        triggerSpark(clickX - 50, clickY - 230);
    };

    const handleRetry = () => {
        navigate('/L2')                 
    };

    return ( 
        <main className='Level2Main'>
            <div className='FixArea' onClick={handleBackgroundClick}>
                
                <svg className="WireLayer">
                    {connectedPairs.red && (
                        <line x1={CONTACTS_CONFIG.red.start.x} y1={CONTACTS_CONFIG.red.start.y} x2={CONTACTS_CONFIG.red.end.x} y2={CONTACTS_CONFIG.red.end.y} className="Wire RedLine" />
                    )}
                    {connectedPairs.green && (
                        <line x1={CONTACTS_CONFIG.green.start.x} y1={CONTACTS_CONFIG.green.start.y} x2={CONTACTS_CONFIG.green.end.x} y2={CONTACTS_CONFIG.green.end.y} className="Wire GreenLine" />
                    )}
                    {connectedPairs.blue && (
                        <line x1={CONTACTS_CONFIG.blue.start.x} y1={CONTACTS_CONFIG.blue.start.y} x2={CONTACTS_CONFIG.blue.end.x} y2={CONTACTS_CONFIG.blue.end.y} className="Wire BlueLine" />
                    )}
                </svg>

                <img 
                    className={`Contact Red1 ${currentStage === 1 ? 'Glowing' : ''} ${selectedContact?.contactId === 'r_s' ? 'Selected' : ''} ${connectedPairs.red ? 'Connected' : ''}`} 
                    src={Red1} alt="" onClick={(e) => handleContactClick(e, 'red', 'start', 'r_s')}
                />
                <img 
                    className={`Contact Red2 ${currentStage === 1 ? 'Glowing' : ''} ${selectedContact?.contactId === 'r_e' ? 'Selected' : ''} ${connectedPairs.red ? 'Connected' : ''}`} 
                    src={Red2} alt="" onClick={(e) => handleContactClick(e, 'red', 'end', 'r_e')}
                />

                <img 
                    className={`Contact Green1 ${currentStage === 2 ? 'Glowing' : ''} ${selectedContact?.contactId === 'g_s' ? 'Selected' : ''} ${connectedPairs.green ? 'Connected' : ''}`} 
                    src={Green1} alt="" style={{ display: currentStage >= 2 || connectedPairs.green ? 'block' : 'none' }} onClick={(e) => handleContactClick(e, 'green', 'start', 'g_s')}
                />
                <img 
                    className={`Contact Green2 ${currentStage === 2 ? 'Glowing' : ''} ${selectedContact?.contactId === 'g_e' ? 'Selected' : ''} ${connectedPairs.green ? 'Connected' : ''}`} 
                    src={Green2} alt="" style={{ display: currentStage >= 2 || connectedPairs.green ? 'block' : 'none' }} onClick={(e) => handleContactClick(e, 'green', 'end', 'g_e')}
                />

                <img 
                    className={`Contact Blue1 ${currentStage === 3 ? 'Glowing' : ''} ${selectedContact?.contactId === 'b_s' ? 'Selected' : ''} ${connectedPairs.blue ? 'Connected' : ''}`} 
                    src={Blue1} alt="" style={{ display: currentStage === 3 || connectedPairs.blue ? 'block' : 'none' }} onClick={(e) => handleContactClick(e, 'blue', 'start', 'b_s')}
                />
                <img 
                    className={`Contact Blue2 ${currentStage === 3 ? 'Glowing' : ''} ${selectedContact?.contactId === 'b_e' ? 'Selected' : ''} ${connectedPairs.blue ? 'Connected' : ''}`} 
                    src={Blue2} alt="" style={{ display: currentStage === 3 || connectedPairs.blue ? 'block' : 'none' }} onClick={(e) => handleContactClick(e, 'blue', 'end', 'b_e')}
                />

                {showSpark && (
                    <img 
                        className='Spark' 
                        src={SparkImg} 
                        alt="Short Circuit Spark" 
                        style={{ left: `${sparkPos.left}px`, top: `${sparkPos.top}px` }} 
                    />
                )}
            </div>

            {isWon && (
                <div className="LoseScreenWrapper"> 
                    <WinScreen RetryClick={handleRetry} LevelPath="/fixed" />
                </div>
            )}
        </main>
     );
}
 
export default Level2;